

export const VideoPage = () => {
    return (
        <div>
            <h2>VideoPage</h2>
        </div>
    )
}

export default VideoPage